import React from 'react';
import { array, func, string } from 'prop-types';

import RadioButtonGroup from 'common/components/Form/RadioButtonGroup';
import { TranslatedMessage } from 'common/components/Intl';

const PodsFilter = ({
  nicotineStrengths,
  selectedNicotineStrength,
  updateNicotineStrength,
}) => {
  const radioButtonProps = nicotineStrengths.map(nicotineStrength => {
    return {
      checked: nicotineStrength === selectedNicotineStrength,
      simple: true,
      text: nicotineStrength,
      value: nicotineStrength,
    };
  });

  return (
    <div className="build-your-plan__nicotine-strength">
      <h4 className="subheading--small">
        <TranslatedMessage id="plan_builder.pod_picker.choose_percent" />
      </h4>
      <RadioButtonGroup
        onChange={e => {
          updateNicotineStrength({ nicotineStrength: e.target.value });
        }}
        inline={true}
        name="percent"
        radioButtonProps={radioButtonProps}
      />
    </div>
  );
};

PodsFilter.propTypes = {
  nicotineStrengths: array.isRequired,
  selectedNicotineStrength: string.isRequired,
  updateNicotineStrength: func.isRequired,
};

export default PodsFilter;
